import React from 'react';
import MoneyExchangeRateRangeItemProperties from "./MoneyExchangeRateRangeItemProperties";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./MoneyExchangeRateRangeItem.style";
import clsx from "clsx";
import ShowInterval from '../../Info/ShowInterval/ShowInterval';
import ShowSimplePrice from '../../Info/ShowSimplePrice/ShowSimplePrice';


const MoneyExchangeRateRangeItem: React.FC<MoneyExchangeRateRangeItemProperties> = ({
                                                        onPaymentsChange = () => {
                                                        },
                                                        className = '',
                                                        agencyId,
                                                        moneyExangeRateId,
                                                        currency,
                                                        moneyExchangeRateRangeItem
                                                    }) => {
    const classes = useStyles();

    return <Observer>
        {() => (
            <div
                className={clsx(classes.exchange_item_container, className)}>
                <ShowInterval
                    from={moneyExchangeRateRangeItem.fromValue}
                    to={moneyExchangeRateRangeItem.toValue}
                    horizontal={false}
                />
                <div>
                    <div className={classes.value_container}>
                        <ShowSimplePrice value={moneyExchangeRateRangeItem.value}/>
                    </div>
                </div>
            </div>
        )}
    </Observer>
}

export default MoneyExchangeRateRangeItem;
